import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InitialsService {
  /**
   * Returns initials from a full name.
   * Examples:
   *  - "John Doe" → "JD"
   *  - "Alice" → "A"
   *  - "" / null → ""
   */
  getInitials(name?: string): string {
    if (!name || !name.trim()) {
      return 'U';
    }
    const parts = name.trim().split(/\s+/).filter(Boolean);

    if (parts.length === 0) return '';

    if (parts.length === 1) {
      // Return first two letters for single-word names (e.g. "Poonam" → "PO")
      return parts[0].slice(0, 2).toUpperCase();
    }

    // Return first letter of first and last name (e.g. "Poonam Pawar" → "PP")
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }
}
